import React from "react";
import { Layout, MintingHistoryComp } from "../components";
import "../assets/css/minting.css";

const MintingHistory = () => {
  return (
    <>
      <Layout>
        <MintingHistoryComp />
      </Layout>
    </>
  );
};

export default MintingHistory;
